import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

export function useWgptAccount() {
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const accountTypeById = useMapGetter('accounts/wgptAccountType');

  const isHubpostCarsAccount = computed(
    () => accountTypeById.value(currentAccountId.value) === 'hubpost_cars'
  );

  return {
    isHubpostCarsAccount,
  };
}
